import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Select } from "antd";

import { useProjectState } from "../../../context/stateContext";
import DatePickerComponent from "../../Common/DatePicker/DatePicker";
import myMenuOrdersActions from "../../../redux/myMenuOrders/actions";
import "./index.css";

const { Option } = Select;
const { myMenuOrders } = myMenuOrdersActions;

const MyMenuOrdersAction = () => {
  const {
    selectedOrganization,
    allSectedRestaurants,
    setAllSelectedRestaurants,
    startDate,
    endDate,
  } = useProjectState();
  const dispatch = useDispatch();
  const { restaurants, organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );

  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      setAllSelectedRestaurants([
        defaultOrganization[0]?.defaultTouchSaleRestaurantId,
      ]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    window.localStorage.setItem("restaurantId", allSectedRestaurants);
    const timer = setTimeout(() => {
      dispatch(myMenuOrders(startDate, endDate, allSectedRestaurants));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allSectedRestaurants, selectedOrganization, startDate, endDate]);

  const handleOnSelectRestaurant = (restaurant) => {
    setAllSelectedRestaurants((prevSelectedRestaurants) => [
      ...prevSelectedRestaurants,
      restaurant,
    ]);
  };

  const handleDeSelectRestaurant = (restaurantToRemove) => {
    setAllSelectedRestaurants((prevSelectedRestaurants) =>
      prevSelectedRestaurants.filter(
        (restaurant) => restaurant !== restaurantToRemove
      )
    );
  };

  return (
    <div className="mymenu-orders-action-buttons-container">
      {defaultOrganization[0]?.multipleRestaurants && (
        <Select
          showSearch={false}
          virtual={false}
          key="mymenyOrdersSelect"
          mode="multiple"
          placeholder="Изберете ресторант"
          onSelect={handleOnSelectRestaurant}
          onDeselect={handleDeSelectRestaurant}
          value={allSectedRestaurants}
          className="mymenu-orders-action-buttons"
        >
          {restaurants?.map((restaurant, index) => (
            <Option
              key={restaurant.id}
              value={restaurant.id}
              className="mymenu-orders-select-option"
            >
              {restaurant.name}
            </Option>
          ))}
        </Select>
      )}
      <DatePickerComponent />
    </div>
  );
};

export default MyMenuOrdersAction;
